import React from 'react'
import clsx from 'clsx'

interface TmcIconProps {
  name: string
  size?: number
  className?: string
}

// CSS mask so the brand icon tints with currentColor (dark mode safe).
const TmcIcon = ({ name, size = 22, className }: TmcIconProps): React.ReactElement => {
  const mask = `url(/icons/tmc/${name}.svg)`
  return (
    <span
      aria-hidden="true"
      className={clsx('inline-block shrink-0', className)}
      style={{
        width: size,
        height: size,
        backgroundColor: 'currentColor',
        maskImage: mask,
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        maskSize: 'contain',
        WebkitMaskImage: mask,
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        WebkitMaskSize: 'contain',
      }}
    />
  )
}

export default TmcIcon
